import React from 'react';
import logo from './logo.svg';
import './App.css';
import ImageData from './components/ImageData';

function App() {
  return (
    <div className="App">
      <ImageData />
    </div>
  );
}

export default App;
